import React, { useCallback } from 'react';
import classNames from "classnames";
import Select, { components } from 'react-select';
import UpCheckbox from "../UpCheckbox";
import DownArrowIcon from '../../../assets/icons/DownArrowIcon';
import "./style.scss"

function UpMultiSelect({
  label,
  name,
  options = [],
  value = [],
  onValueChange,
  requiredLabel = false,
  wrapperClass = '',
  labelKey = 'label',
  valueKey = 'value',
  isLoading = false,
  isSearchable = true,
  isClearable = true,
  isAsync = false,
  handleSearch,
  placeholder = 'Select',
  noOptionsMessage = 'No results found',
  errorContent,
  helpContent,
  isDisabled = false,
}) {
  const handleSearchInput = useCallback(
		(inputValue) => {
			if (isAsync) {
				handleSearch(inputValue);
			}
		},
		[isAsync, handleSearch]
	);

  function CustomOptionContainer({ children, ...props }) {
    return (
			<components.Option {...props}>
				<UpCheckbox
          label={children}
          value={props.isSelected}
          onChange={() => void 0}
        />
			</components.Option>
		);
  }

  function CustomDropdownIndicator({ children, ...props }) {
    return (
      <components.DropdownIndicator {...props}>
        <DownArrowIcon />
      </components.DropdownIndicator>
    );
  }

  function getHelpErrorContent() {
    if (errorContent) {
      return <div className="error-content">{errorContent}</div>;
    }

    if (helpContent) {
      return <div className="help-content">{helpContent}</div>;
    }

    return null;
  }

  return (
    <div className={classNames("up-multi-select", errorContent ? "error" : "", wrapperClass)}>
      {label && <label className={classNames("label", requiredLabel ? "required-label" : "")}>{label}</label>}
      <Select
        isMulti={true}
        options={options}
        name={name}
        value={value}
        onChange={onValueChange}
        isLoading={isLoading}
        isSearchable={isSearchable}
        isClearable={isClearable}
        isDisabled={isDisabled}
        labelKey={labelKey}
        valueKey={valueKey}
        getOptionLabel={(option) => option[labelKey]}
        getOptionValue={(option) => option[valueKey]}
        onInputChange={handleSearchInput}
        hideSelectedOptions={false}
        closeMenuOnSelect={false}
        classNamePrefix="react-select"
        placeholder={placeholder}
        noOptionsMessage={() => noOptionsMessage}
        components={{ 
          Option: CustomOptionContainer,
          DropdownIndicator: CustomDropdownIndicator
        }}
      />
      {getHelpErrorContent()}
    </div>
  );
}
export default UpMultiSelect
